import { render, staticRenderFns } from "./itemCreate.vue?vue&type=template&id=2062e5f8&scoped=true&lang=html&"
import script from "./itemCreate.vue?vue&type=script&lang=js&"
export * from "./itemCreate.vue?vue&type=script&lang=js&"
import style0 from "./itemCreate.vue?vue&type=style&index=0&id=2062e5f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2062e5f8",
  null
  
)

export default component.exports